import { useTranslation } from "@sagot/i18n";
import { Button, Tooltip, type ButtonProps } from "@sagot/ui";
import { useIsManualBilling } from "./manual-billing";

type GatedButtonProps = ButtonProps & { allowed: boolean };

/**
 * A billing action: disabled with a reason tooltip when it cannot run. The reason is "no
 * permission" (`billing.manage` missing) or, for a workspace billed by invoice, "contact sales".
 */
export function GatedButton({ allowed, ...props }: GatedButtonProps) {
  const { t } = useTranslation();
  const manual = useIsManualBilling();
  if (allowed) return <Button {...props} />;
  return (
    <Tooltip content={manual ? t("billing.manual.gated") : t("console.noPermission")}>
      <span className="inline-flex">
        <Button {...props} aria-disabled="true" className={props.className ? `${props.className} cursor-not-allowed opacity-50` : "cursor-not-allowed opacity-50"} onClick={undefined} />
      </span>
    </Tooltip>
  );
}
